/* istanbul ignore file */
import React, { useEffect, useState } from 'react';
import { Fade, Loading, SmallLoader } from 'framework/ui/mui-builder';
import { Box } from '@mui/material';

interface LoadingDecoratorProps {
  children: React.ReactNode;
  isSmallLoader?: boolean;
  loading?: boolean;
  items?: any[];
  deps: any[];
  saveRenderedContent?: boolean;
}

const LoadingDecorator = ({
  children,
  isSmallLoader = false,
  loading = false,
  deps,
  saveRenderedContent,
}: LoadingDecoratorProps) => {
  const [dataLoading, setDataLoading] = useState(true);
  const isLoading = loading || dataLoading;
  const hasContent = saveRenderedContent || !dataLoading;
  const loader = isSmallLoader ? <SmallLoader /> : <Loading hasBackground />;

  useEffect(() => {
    if (loading) {
      setDataLoading(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);

  useEffect(() => {
    setDataLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return (
    <>
      {isLoading ? loader : null}
      <Fade in={!isLoading || (isLoading && hasContent)} timeout={20}>
        <Box
          sx={
            isLoading && !hasContent
              ? {
                  position: 'absolute',
                  clip: 'rect(0 0 0 0)',
                  width: '1px',
                  height: '1px',
                  m: '-1px',
                  overflow: 'hidden',
                }
              : undefined
          }
        >
          {children}
        </Box>
      </Fade>
    </>
  );
};

export default LoadingDecorator;
